"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewPort = exports.getLinesRange = exports.getEquityOffsetArrayForAll = exports.getLinearOffset = exports.getEquityOffsetArray = exports.sumTwoArrays = void 0;
const types_1 = require("../types");
const sumTwoArrays = (a1, a2) => {
    if (a1.length !== a2.length) {
        throw new Error("Array size not the same");
    }
    let res = new Array(a1.length).fill(0);
    for (let i = 0; i < a1.length; i++) {
        res[i] = a1[i] + a2[i];
    }
    return res;
};
exports.sumTwoArrays = sumTwoArrays;
const getEquityOffsetArray = (equity, indexPrice, domain, currencyType, chartType) => {
    return currencyType === types_1.CurrencyType.FIAT
        ? domain.map((x) => chartType === types_1.ChartType.Equity
            ? x * equity
            : x * equity - indexPrice * equity)
        : domain.map((x) => (chartType === types_1.ChartType.Equity ? equity : 0));
};
exports.getEquityOffsetArray = getEquityOffsetArray;
/**
 * We dont drop the equity for linears. Reason is that that would simulate
 * drop in usdc_usd index. We do simulate drop in the underlying index.
 *
 * For example we have sol_usdc position and 1000 usdc equity.
 * For 50% down we consider drop in sol_usdc index but the equity would still
 * stay the same.
 * For inverse we drop the equity as well.
 */
const getLinearOffset = (domain, chartType, equity, ignoreEquity) => {
    if (chartType === types_1.ChartType.ChangePnl) {
        return domain.map((_) => 0);
    }
    if (chartType === types_1.ChartType.Equity) {
        return domain.map((_) => equity);
    }
    return domain.map((_) => (ignoreEquity ? 0 : equity));
};
exports.getLinearOffset = getLinearOffset;
const getEquityOffsetArrayForAll = (domains, equities, indices, chartType, ignoreEquity) => {
    let offsetArray = new Array(domains[types_1.Currency.ALL].length).fill(0);
    for (const currentCurrency of [types_1.Currency.BTC, types_1.Currency.ETH]) {
        const currentOffset = (0, exports.getEquityOffsetArray)(equities[currentCurrency].updatedEquity, indices[currentCurrency], domains[currentCurrency], types_1.CurrencyType.FIAT, chartType);
        offsetArray = (0, exports.sumTwoArrays)(offsetArray, currentOffset);
    }
    const usdcOffset = (0, exports.getLinearOffset)(domains[types_1.Currency.USDC], chartType, equities[types_1.Currency.USDC].updatedEquity, ignoreEquity);
    return (0, exports.sumTwoArrays)(offsetArray, usdcOffset);
};
exports.getEquityOffsetArrayForAll = getEquityOffsetArrayForAll;
const getLinesRange = (lines) => {
    let min = Number.MAX_SAFE_INTEGER;
    let max = Number.MIN_SAFE_INTEGER;
    for (let line of lines) {
        min = Math.min(Math.min(...line, min));
        max = Math.max(Math.max(...line, max));
    }
    return { min, max };
};
exports.getLinesRange = getLinesRange;
const getViewPort = (chartState) => {
    let { min: yMin, max: yMax } = (0, exports.getLinesRange)([
        chartState.chartLines.expireLine.values,
        chartState.chartLines.todayLine.values,
    ]);
    let { min: xMin, max: xMax } = (0, exports.getLinesRange)([chartState.xAxisValues]);
    return {
        x: {
            start: xMin,
            end: xMax,
        },
        y: {
            start: Math.min(-0.01, yMin * 1.2),
            end: Math.max(0.01, yMax * 1.2),
        },
    };
};
exports.getViewPort = getViewPort;
